var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconNoRatingStar = function SvgIconNoRatingStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 19,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m10 15.717-5.878 3.29L5.435 12.4.49 7.827l6.689-.793L10 .917l2.822 6.117 6.689.793-4.946 4.573 1.313 6.607zm0-1.91 3.54 1.98-.791-3.977 2.977-2.754L11.7 8.58 10 4.896 8.302 8.58l-4.028.477 2.978 2.754-.79 3.978z"
  })));
};
export default SvgIconNoRatingStar;